import React, {useState} from 'react'
import './Addmovie.css'
import axios from 'axios';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import BASE_URL from '../../constant';

function Addmovie() {
    const [movie, setmovie] = useState({
        moviename : "",
        description : "",
        videoTrailerLink : "",
        cast : '',
        language: "",
        releaseDate : "",
        movieLen : 0,
        rating : 0
    });

    const navigate = useNavigate();
    // const [errmsg, setErrmsg] = useState("");
    const [image, setImage] = useState(null);
    const [, setImagePreview] = useState(null);

    const [image2, setImage2] = useState(null);
    const [, setImage2Preview] = useState(null);

    const [rstatusSelectedValue, setRstatusSelectedValue] = useState("");
    const [genreval, setGenreVal] = useState("");
    const storedAdmin = JSON.parse(localStorage.getItem("adminData"));
    const [logStatus, setLogStatus] = useState(true);

    useEffect(()=>{
      if(!storedAdmin){
        setLogStatus(false)
        return
      }
    },[storedAdmin])
    
    const handleChange = (e)=>{
        const {name, value} = e.target;
        setmovie({
            ...movie,
            [name] : value
        })
  
    }

    const createmovieImagesChange = (e) => {
      const file = e.target.files[0];
      setImage([]);
      setImagePreview([]);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.readyState === 2) {
          setImagePreview((old) => [...old, reader.result]);
          setImage((old) => [...old, reader.result]);
        }
      };
    };

    const createmovieImages2Change = (e) => {
      const file = e.target.files[0];
      setImage2([]);
      setImage2Preview([]);
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        if (reader.readyState === 2) {
          setImage2Preview((old) => [...old, reader.result]);
          setImage2((old) => [...old, reader.result]);
        }
      };
    };

    const handleSubmit = (e)=>{
      e.preventDefault();
      const formData = new FormData();
      
      const langArr = movie.language.split(",");
      const castArr = movie.cast.split(",")


      if(!movie.moviename ){
        console.log("Movie's name is must please provide it",movie);
        return;
      }else if(!movie.description){
        console.log("Movie description not provided");
        return;
      }else if(!movie.movieLen){
        console.log("Movie Length not provided");
        return;
      }else if(!movie.cast){
        console.log("Movie cast not provided");
        return;
      }else if(!movie.language){
        console.log("Movie Languages not provided");
        return;
      }else if(!movie.releaseDate){
        console.log("Movie Release Date not provided");
        return;
      }else if(!rstatusSelectedValue){
        console.log("Movie's Released Status not provided");
        return;
      }else if(!genreval){
        console.log("Movie's Genre not provided");
        return;
      }else if(!movie.videoTrailerLink){
        console.log("Video trailer link not provided");
        return;
      }else if(!movie.rating){
        console.log("Movie's Rating not provided");
        return;
      }

  
      formData.set("name", movie.moviename);
      formData.set("desc", movie.description);
      formData.set("cast", castArr);
      formData.set("language", langArr);
      formData.set("releaseDate", movie.releaseDate);
      formData.set('releaseStatus', rstatusSelectedValue);
      formData.set('genre', genreval);
      formData.set('movieLength', movie.movieLen);
      formData.set('rating', movie.rating); 
      formData.set('videoTrailer', movie.videoTrailerLink); 
      formData.append("posterImage", image);
      formData.append("backImage", image2);
      console.log("Movie data set");


      // To check the entries of formData
      for (let pair of formData.entries()) {
        console.log(pair[0], pair[1]);
      }
      // return;

      axios.post(`${BASE_URL}/bookmyshow/api/v1/movie`,formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((res)=>{
        console.log(res.data);
        navigate('/admin')
      })
      .catch((err)=>console.log(err));
  
    }


  return (
    <div className="addmoviesCont">

    { (!logStatus) ? "Unauthorised access" : 
    <form className="form addMovie-form"  method="post" encType="multipart/form-data">
      <div className="flex">
      <div className="input-field">
        <span>Movie Name</span>
        <input required={true} onChange={handleChange} name="moviename" value={movie.moviename} type="text" className="input" />
      </div>
      <div className="input-field">
        <span>Video Trailer Link</span>
        <input required={true} onChange={handleChange} name="videoTrailerLink" value={movie.videoTrailerLink} type="text" className="input" />
      </div>
      </div>
      <div className="input-field">
      <span>Short Description of story</span>
      <textarea required={true} onChange={handleChange}  value={movie.description}  name="description" id="description" cols="30" rows="3" className='textarea'></textarea>
      </div>
      
      <div className="flex">
        <div className="input-field">
          <span>Cast</span>
          <input required={true} placeholder='Robert Downey Jr , Chris Evans ...' onChange={handleChange} name="cast" value={movie.cast} type="text" className="input" />
        </div>
        <div className="input-field">
          <span>Language</span>
          <input required={true} placeholder='hindi, english, tamil, ...' onChange={handleChange} name="language" value={movie.language} type="text" className="input" />
        </div>
        
      </div>
     <div className="flex">
        <div className="input-field">
          <span>Release Date</span>
          <input required={true} onChange={handleChange} name="releaseDate" value={movie.releaseDate} type="date" className="input" />
        </div>
        <div className="input-field">
        <span>Release Status</span>
        <select required={true} value={rstatusSelectedValue} onChange={(e) => setRstatusSelectedValue(e.target.value)} name="releaseStatus" id="rstatus">
            <option value="">None</option>
            <option value="Released">Released</option>
            <option value="Not Released Yet">Not Released Yet</option>
        </select>
        </div>
        <div className="input-field">
          <span>Genre</span>
          <select required={true} value={genreval} onChange={(e) => setGenreVal(e.target.value)} name="genre" id="genre">
            <option value="">None</option>
            <option value="Action">Action</option>
            <option value="Thriller">Thriller</option>
            <option value="Sci-Fi">Sci-Fi</option>
            <option value="Romantic">Romantic</option>
            <option value="Drama">Drama</option>
            <option value="Comedy">Comedy</option>
            <option value="Family">Family</option>
            <option value="Adventure">Adventure</option>
            <option value="Sports">Sports</option>
            <option value="Biopic">BioPic</option>
        </select>
        </div>
     </div>
     
     <div className="flex">
        <div className="input-field">
          <span>Movie Length</span>
          <input required={true} placeholder='0h 00m' onChange={handleChange} name="movieLen" value={movie.movieLen} type="text" className="input" />
        </div>
        <div className="input-field">
          <span>Rating /10</span>
          <input required={true} onChange={handleChange} name="rating" value={movie.rating} type="text" className="input" />
        </div>
     </div>
      <div className="flex">
      
          <div className="imageFlex">
            <div className="input-field">
            <span>Poster Image</span>
            <input required={true} onChange={createmovieImagesChange} type="file" className="fileinput" accept="image/*" /><br />
            </div>
            <div id="createmovieFormImage" className='prev-posterImg'>
              {image && <img src={image} alt="Movie Poster Preview" />}
            </div>
          </div>
      
          <div className="imageFlex">
            <div className="input-field">
              <span>Background Image</span>
              <input required={true} onChange={createmovieImages2Change} type="file" className="fileinput" accept="image/*" /><br />
            </div>
            <div id="createmovieFormImage">
              {image2 && <img src={image2} alt="Background movie Preview" />}
            </div>
          </div>
      </div>
      <div className="submitBtnContainer">
        <button className="submitBtn" onClick={handleSubmit} >
          Add Movie
        </button>
      </div>
    </form>
}    
  </div>
  )
}

export default Addmovie
